export default "__VITE_ASSET__1b7938fa__"